<template>
    <ul
        v-if="show"
        v-focus-out="onFocusOut"
        :class="`navigation-dropdown position-${position}`"
    >
        <li v-for="(item, index) in items" :key="index" @click="$emit('close')">
            <router-link
                v-if="item.url"
                :id="item.id"
                class="fill-space"
                :to="item.url"
            >
                {{ item.name }}
            </router-link>
            <div
                v-else-if="item.action"
                :id="item.id"
                class="fill-space"
                @click="$emit('update', item.action)"
            >
                {{ item.name }}
            </div>
        </li>
    </ul>
</template>
<script>
export default {
    name: "NavigationDropdown",
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
        position: {
            type: Number,
            default: 1,
        },
    },
    emits: ["close", "update"],
    data() {
        return {};
    },
    methods: {
        onFocusOut() {
            if (this.show) {
                this.$emit("close");
            }
        },
    },
};
</script>
